import { comboQuery } from './query.gql';
import { comboTransformer } from './pd.transformer';
import { CookieService } from '~/src/libs/cookie';
import { Fetcher } from '@bigbasket/fetcher';
import { sendNewRelicEventOnError } from '~/src/libs/newRelicEvent';
import { COMMONHEADERS } from '../Common/commonHeader';

const PDService = (() => {
  const getComboProducts = async (productIds = []) => {
    const body = {
      query: comboQuery,
      list_type: 'summary',
      variables: { ids: [...productIds] },
    };
    const userType = CookieService.getCookie('_bb_mid') ? 'member' : 'visitor';
    try {
      const res = await Fetcher.clientSidePostRequest(`/pd-svc/v1/${userType}/gql/`, COMMONHEADERS, body);
      if (res.httpStatus === '200') {
        return comboTransformer(res?.data?.getProducts);
      }
      sendNewRelicEventOnError(`/pd-svc/v1/${userType}/gql/`, res);
    } catch (err) {
      sendNewRelicEventOnError(`/pd-svc/v1/${userType}/gql/`, err);
    }
  };

  return { getComboProducts };
})();

export { PDService };
